import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Wifi, Bell, ClipboardList, Play } from 'lucide-react';
import { PageContainer } from '../../components/layout/PageContainer/PageContainer';
import { QuickActions } from '../../components/features/QuickActions/QuickActions';
import { MoodPresets } from '../../components/features/MoodPresets/MoodPresets';
import { Button } from '../../components/ui/Button/Button';
import { useRoomStore } from '../../stores/roomStore';
import { useUIStore } from '../../stores/uiStore';
import { heroImages } from '../../data/mockData';

export const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const { activePreset, applyMoodPreset, devices } = useRoomStore();
  const { openModal } = useUIStore();

  const quickActions = [
    { id: 'wifi', label: t('home.quickActions.wifi'), icon: <Wifi className="w-5 h-5" />, onClick: () => openModal('wifi') },
    { id: 'reception', label: t('home.quickActions.reception'), icon: <Bell className="w-5 h-5" />, onClick: () => openModal('reception') },
    { id: 'room-service', label: t('home.quickActions.roomService'), icon: <ClipboardList className="w-5 h-5" />, onClick: () => openModal('room-service') },
    { id: 'tour', label: t('home.quickActions.tour'), icon: <Play className="w-5 h-5" />, onClick: () => openModal('tour') },
  ];

  // Count active devices
  const activeDevicesCount = devices.filter(d => d.status === 'on').length;

  return (
    <PageContainer
      heroImage={heroImages.home}
      heroHeight="large"
      heroTitle={
        <>
          {t('home.welcome')} <br />
          Leela Palace Udaipur!
        </>
      }
      overlayOpacity={0.5}
      showWeather={true}
      searchBar={
        <button
          onClick={() => openModal('search')}
          className="flex items-center gap-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm px-4 py-2.5 rounded-full text-white transition-all duration-300 border border-white/30 w-[300px]"
        >
          <Search className="w-5 h-5" />
          <span className="text-sm font-medium">{t('home.searchPlaceholder')}</span>
        </button>
      }
    >
      {/* Hero Text Content */}
      <div className="mb-8">
        <p className="text-[#666666] text-base leading-relaxed max-w-2xl">
          {t('home.subtitle')}
        </p>
      </div>

      {/* Quick Actions */}
      <div className="mb-12">
        <QuickActions actions={quickActions} />
      </div>

      {/* Room Controls Preview */}
      <div className="bg-white rounded-2xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-display text-2xl text-[#333333] mb-1">{t('home.roomControls')}</h2>
            <p className="text-sm text-[#666666]">
              {t('home.devicesActive', { count: activeDevicesCount })}
            </p>
          </div>
          <Button variant="secondary" size="sm">
            {t('home.seeAll')}
          </Button>
        </div>

        {/* Mood Presets */}
        <MoodPresets
          activePreset={activePreset}
          onSelect={applyMoodPreset}
        />
      </div>
    </PageContainer>
  );
};

export default HomePage;
